export const updateCanvasVars = (canvas) => {
    const w = canvas.clientWidth;
    const h = canvas.clientHeight;
    const root = document.documentElement;
  
    root.style.setProperty('--vw', `${w / 100}px`);
    root.style.setProperty('--vh', `${h / 100}px`);
    root.style.setProperty('--vmin', `${Math.min(w, h) / 100}px`);
    root.style.setProperty('--vmax', `${Math.max(w, h) / 100}px`);
  };